// //	未知错误，请联系管理员
// export const ERROR_UNKNOWN = -1
// // 	用户名密码错误(图片)
// export const ERROR_USER_INFO = 100002
// //	用户名密码错误(短信)
// export const ERROR_USER_INFO_IMG_CODE = 100003
// //	需要进行短信验证码验证
// export const ERROR_USER_INFO_MSG = 100012
// //图片验证码错误
// export const ERROR_USER_INFO_IMG_ERROR = 100004
// // 账号状态异常
// export const ERROR_ACCOUNT_ABNORMAL = 200014
// // 账号密码错误
// // export const ERROR_USER_ACCOUNT_PASSWORD_ERROR = 200009
// //	淘宝风控验证失败
// export const ERROR_ALI_RISK = 300001
// //	京东风控验证失败
// export const ERROR_JD_RISK = 300002
// //手机校验失败
// export const ERROR_MOBILE_CHECK = 100007
// //短信验证码验证失败
// export const ERROR_SHORT_MESSAGE_CHECK = 100013
// // easy注册下， 电话已注册
// export const ERROR_MOBILE_NUM_REGISTERED = 100062
// // 员工已经被停用
// export const ERROR_STAFF_HAVE_STOPED = 200010

// loginStatus.value = [0, 1] 员工merchantId错误
export const ERROR_STAFFLOGIN_MERCHANTID = 1
// loginStatus.value = [0, 2] 卖家merchantId错误
export const ERROR_MERCHANTLOGIN_MERCHANTID = 2

// 安全中心对用设置的code

// 0 -风险等级(高)-未设置定期修改密码
export const TO_CHANGE_PASSWORD_REGULARLY = 0
// 1 -风险等级(中)-未设置登录限制
export const TO_SETTING_LOGIN_LIMINT = 1
// 2 -风险等级(中)-员工被分配可操作权限
export const TO_STOP_STAFF_WRITE_JURISDICTION = 2
// 3 -风险等级(低)-员工被分配可访问权限
export const TO_STOP_STAFF_READ_JURISDICTION = 3
// 4 -风险等级(低)-超过30天未登录
export const TO_STOP_STAFF = 4

// 登录日志对应的tab页
// 1-登录日志
export const LOGIN_LOG = '1'
// 2-安全操作日志
export const SECURITY_OPERATION_LOG = '2'
// 3-员工操作日志
export const STAFF_OPERATION_LOG = '3'
// 4-授权日志
export const ACCESS_TOKEN_LOG = '4'

// ip黑白名单列表对应tab
// 1-ip黑名单
export const IP_BLACK_LIST = '2'
// 2-ip白名单
export const IP_WHITE_LIST = '1'
// 3-员工白名单
export const STAFF_WHITE_LIST = '3'

// 打开窗口的类型
// 0-新增ip名单
export const TO_ADD_IP = 0
// 1-修改ip
export const TO_MODIFY_IP = 1

export const AliURL = 'https://open.taobao.com/announcement.htm?docId=24969&docType=12';
  //'https://eco-doc.alibaba.com/docs/doc.htm?spm=a219a.7386653.1.165.7a254de0WqqASn&treeId=227&articleId=105392&docType=1';

export const JDURL = 'https://open.jd.com/home/home#/doc/common?listId=1315'
export const HUICE_DEFAULT_URL =
  import.meta.env.VITE_ENV === 'prod'
    ? 'https://login.huice.com/'
    // : 'https://pre-login.huice.com/'
      : 'https://login-dev.huice.com/'

export enum ProjectId {
  //企业版
  ERP2 = 'erp2',
  //旗舰版
  ERP3 = 'epr3',
  //E快帮
  EKB = 'ekb',
  //发的快
  FDK = 'fdk',
  //铺得快
  PDK = 'pdk',
  //慧经营
  HJY = 'hjy',
  //Y项目
  YXM = 'YXM',
}

// 域名白名单
export const ALLOW_LIST = ['huice.com', 'wangdian.cn']

export const WEB_PRODUCT_MAP = {
  local: {
    'https://erpxtest.huice.com': ProjectId.YXM,
    'https://hjy.huice.com': ProjectId.HJY,
  },
  test: {
    'https://erpxtest.huice.com': ProjectId.YXM,
    'https://hjy.huice.com': ProjectId.HJY,
  },
  'test-v2': {
    'https://erpxtest.huice.com': ProjectId.YXM,
    'https://hjy.huice.com': ProjectId.HJY,
  },
}

export const getProductId = (host) => {
  if (
    [
      'https://hjy.huice.com',
      'https://hjytest.jst.huice.cn',
      'https://hjytest-dev1.jst.huice.cn',
      'https://hjyprod.huice.com',
    ].includes(host)
  ) {
    return ProjectId.HJY
  } else if (
    ['https://erpxtest.huice.com', 'https://erp.huice.com'].includes(host)
  ) {
    return ProjectId.YXM
  }
  return ''
}

export const WEB_PRODUCT_URLS = {
  local: {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erpxtest.huice.com',
    },
    4: {
      url: 'https://fx-test-1.huice.com/',
    },
    5: {
      url: 'https://hjytest.jst.huice.cn/',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
  test: {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erpxtest.huice.com',
    },
    4: {
      url: 'https://fx-test-3.huice.com/',
    },
    5: {
      url: 'https://hjytest-dev1.jst.huice.cn',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
  'test-v2': {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erpxtest.huice.com',
    },
    4: {
      url: 'https://fx-test-3.huice.com/',
    },
    5: {
      url: 'https://hjytest.jst.huice.cn/',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
  'pre-beta': {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erpxtest.huice.com',
    },
    4: {
      url: 'https://fx-pre-1.huice.com/',
    },
    5: {
      url: 'https://hjyprod.huice.com',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
  pre: {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erpxtest.huice.com',
    },
    4: {
      url: 'https://fx-test-3.huice.com/',
    },
    5: {
      url: 'https://hjyprod.huice.com',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
  prod: {
    1: {
      url: 'https://www.wangdian.cn/erpCompany.html',
    },
    2: {
      url: 'https://www.wangdian.cn/erpFlagship.html',
    },
    3: {
      url: 'https://erp.huice.com',
    },
    4: {
      url: 'https://fx.huice.com',
    },
    5: {
      url: 'https://hjy.huice.com/',
    },
    6:{
      url: 'https://www.wangdian.cn/',
    }
  },
}

export enum RegisterFrom {
  normal = 1,
  easy = 2
}
